import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-waves-apply-to-selector-feature',
	templateUrl:'./WavesApplyToSelectorFeaturePluginCompPage.html',
	styles: [],
	styleUrls:['./WavesApplyToSelectorFeaturePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WavesApplyToSelectorFeaturePluginCompPage
{
	mdContent_1150 = `\`\`\`java
import com.jwebmp.plugins.waveseffect.WavesApplyToSelectorFeature;
\`\`\``;
	mdContent_1151 = `\`\`\`java
String selector, WavesEffects... classes
\`\`\``;
	mdContent_1152 = `\`\`\`java
var feature = new WavesApplyToSelectorFeature(".btn",
    WavesEffects.Waves_Light, WavesEffects.Waves_Circle);
page.getBody().addFeature(feature);
\`\`\``;
	mdContent_1153 = `\`\`\`java
var feature = new WavesApplyToSelectorFeature(".fab",
    WavesEffects.Waves_Effect, WavesEffects.Waves_Float);
page.getBody().addFeature(feature);
\`\`\``;
}
